export default "__VITE_ASSET__ySVS28UL__"